"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMatrixData = void 0;
const react_1 = require("react");
const use_get_all_attribute_values_hook_1 = require("./use-get-all-attribute-values.hook");
const use_get_all_l1_categories_and_terminal_nodes_hook_1 = require("./use-get-all-l1-categories-and-terminal-nodes.hook");
const use_get_product_attribute_values_for_strategy_matrix_hook_1 = require("./use-get-product-attribute-values-for-strategy-matrix.hook");
const use_get_total_class_sku_count_hook_1 = require("./use-get-total-class-sku-count.hook");
const useMatrixData = ({ selectedAttribute, selectedStrategyNodeId, selectedCatalogId, selectedProductTreeId, selectedL1Categories, }) => {
    const catalogIds = (0, react_1.useMemo)(() => (selectedCatalogId ? [selectedCatalogId] : []), [selectedCatalogId]);
    const selectedProductTreeNodeIds = (0, react_1.useMemo)(() => ((selectedL1Categories === null || selectedL1Categories === void 0 ? void 0 : selectedL1Categories.length) > 0
        ? selectedL1Categories.map((category) => category.value)
        : [selectedStrategyNodeId]), [selectedL1Categories, selectedStrategyNodeId]);
    const { data: terminalNodesDataForCellsAndAttributeValuesTotals = { terminalNodesData: [], totalProductsCount: [] }, error: productAttributesError, isLoading: productAttributesLoading, } = (0, use_get_product_attribute_values_for_strategy_matrix_hook_1.useGetProductAttributesValuesForStrategyMatrix)({
        ids: catalogIds,
        attribute: selectedAttribute,
        productTreeId: selectedProductTreeId,
        productTreeNodeIds: selectedProductTreeNodeIds,
    });
    const { data: attributeValuesData = [], error: attributeValuesError, isLoading: attributeValuesLoading, } = (0, use_get_all_attribute_values_hook_1.useGetAllAttributeValuesForStrategyMatrix)({
        catalog: selectedCatalogId,
        productTreeNodeId: selectedStrategyNodeId,
        selectedAttribute,
    });
    const { data: totalClassSkuCount, error: totalClassSkuError, IsLoading: totalClassSkuLoading, } = (0, use_get_total_class_sku_count_hook_1.useGetTotalClassSkuCountForStrategyMatrix)({
        catalog: selectedCatalogId,
        productTreeId: selectedProductTreeId,
        selectedAttribute,
    });
    const { data: l1CategoriesData, isLoading: l1CategoriesLoading, error: l1CategoriesError, } = (0, use_get_all_l1_categories_and_terminal_nodes_hook_1.useGetAllL1CategoriesAndTerminalNodesForStrategyMatrix)({
        productTreeNodeId: selectedStrategyNodeId,
        catalogId: selectedCatalogId,
        options: {
            skip: !selectedStrategyNodeId || (selectedL1Categories === null || selectedL1Categories === void 0 ? void 0 : selectedL1Categories.length) > 0,
            fetchPolicy: 'cache-first',
        },
    });
    const isLoading = productAttributesLoading || attributeValuesLoading || totalClassSkuLoading || l1CategoriesLoading;
    const error = productAttributesError || attributeValuesError || totalClassSkuError || l1CategoriesError;
    return {
        terminalNodesDataForCellsAndAttributeValuesTotals,
        attributeValuesData,
        totalClassSkuCount,
        isLoading,
        error,
        l1CategoriesData,
    };
};
exports.useMatrixData = useMatrixData;
